export default function parseLink(entry) {
    return {
        title: entry.fields.text || entry.fields.title,
        text: entry.fields.text || entry.fields.title,
        href: entry.fields.href || entry.fields.url,
        target: entry.fields.target,
    }
}
